import { render, staticRenderFns } from "./serviceItemTable.vue?vue&type=template&id=f1476586&scoped=true"
import script from "./serviceItemTable.vue?vue&type=script&lang=js"
export * from "./serviceItemTable.vue?vue&type=script&lang=js"
import style0 from "./serviceItemTable.vue?vue&type=style&index=0&id=f1476586&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1476586",
  null
  
)

export default component.exports